import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

interface PreviewBoxProps {
  children: React.ReactNode;
  height?: number;
  baseWidth?: number;
  baseHeight?: number;
  className?: string;
}

const PreviewBox: React.FC<PreviewBoxProps> = ({
  children,
  height = 220,
  baseWidth = 1000,
  baseHeight = 600,
  className = "",
}) => {
  const outerRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  const recalc = () => {
    const el = outerRef.current;
    if (!el) return;
    const w = el.clientWidth;
    const h = el.clientHeight;

    if (w === 0 || h === 0) {
      requestAnimationFrame(recalc);
      return;
    }
    const z = Math.min(w / baseWidth, h / baseHeight);
    setScale(Math.max(0.01, z));
  };

  useLayoutEffect(() => {
    recalc();
  }, []);
  useEffect(() => {
    const ro = new ResizeObserver(recalc);
    if (outerRef.current) ro.observe(outerRef.current);
    window.addEventListener("resize", recalc);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", recalc);
    };
  }, []);

  return (
    <div
      ref={outerRef}
      className={`relative flex w-full items-center justify-center overflow-hidden rounded-lg border border-gray-200 bg-white ${className}`}
      style={{ height }}
    >
      <div
        style={{
          width: baseWidth * scale,
          height: baseHeight * scale,
          overflow: "hidden",
          pointerEvents: "none",
        }}
      >
        <div
          style={{
            width: baseWidth,
            height: baseHeight,
            transform: `scale(${scale})`,
            transformOrigin: "top left",
          }}
        >
          <div className="flex h-full w-full items-center justify-center">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewBox;
